import { useState } from 'react';

interface FieldProps {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (v: string) => void;
  secret?: boolean;
}

export default function Field({ label, placeholder, value, onChange, secret }: FieldProps) {
  const [show, setShow] = useState(false);
  return (
    <div className="form-group">
      <label>{label}</label>
      <div className="input-wrapper">
        <input
          className="form-input"
          type={secret && !show ? 'password' : 'text'}
          placeholder={placeholder}
          value={value}
          onChange={e => onChange(e.target.value)}
        />
        {secret && (
          <button type="button" className="input-reveal" onClick={() => setShow(s => !s)}>
            {show ? 'Hide' : 'Show'}
          </button>
        )}
      </div>
    </div>
  );
}
